import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/international-shipping-and-storage-services.jpg'),
    alt: 'international shipping and storage services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'international shipping and storage services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'International <span>Shipping</span><span>And Storage Services</span>',
  description:
    'Experience seamless international shipping and secure storage services tailored to your personal and business needs. Our solutions ensure convenience, affordability, and reliability across borders.',
  image: {
    url: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/hero-image.jpg',
    alt: 'International Shipping And Storage Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Get Shipping & Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our International Shipping and Storage Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/how-our-international-shipping-and-storage-services-work.png',
    alt: 'How Our International Shipping and Storage Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Customizable Shipping Options',
      description:
        'Choose the service that fits your needs, including express delivery or cost-effective standard options.',
      image: {
        src: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/customizable-shipping-options.png',
        alt: 'Customizable Shipping Options'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Facilities',
      description:
        'Keep your belongings safe in our climate-controlled and monitored storage units until ready for shipment.',
      image: {
        src: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/secure-storage-facilities.png',
        alt: 'Secure Storage Facilities'
      }
    },
    {
      id: 3,
      title: 'Global Logistics Expertise',
      description:
        'We handle customs, documentation, and transport, ensuring a hassle-free international shipping experience.',
      image: {
        src: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/global-logistics-expertise.png',
        alt: 'Global Logistics Expertise'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'International Storage And Shipping Options',
  description:
    'We offer comprehensive international storage and shipping solutions designed to ensure your goods are secure and accessible. With our efficient logistics and reliable services, you can trust us to handle your shipping needs, providing you with peace of mind throughout the entire process.',
  image: {
    src: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/international-storage-and-shipping-options.jpg',
    alt: 'International Storage And Shipping Options'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Services',

  cards: [
    {
      id: 1,
      title: 'Global Reach',
      description: 'Ship to over 220 countries and territories with trusted international logistics partners.',
      image: {
        src: '/images/v2/pages/common/global-reach.png',
        alt: 'Global Reach'
      }
    },
    {
      id: 2,
      title: 'Secure Storage',
      description: 'Store your belongings safely in monitored facilities until they are ready to be shipped.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Secure Storage'
      }
    },
    {
      id: 3,
      title: 'Affordable Pricing',
      description: 'Competitive rates and customizable plans ensure you pay only for what you need.',
      image: {
        src: '/images/v2/pages/common/affordable-storage-plans.png',
        alt: 'Affordable Pricing'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our International Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Businesses',
          description: 'Expand your global operations with efficient shipping and secure storage solutions.'
        },
        {
          id: 2,
          title: 'Expats',
          description: 'Easily relocate your belongings to any destination with our hassle-free services.'
        },
        {
          id: 3,
          title: 'Students Studying Abroad',
          description: 'Store and ship your personal items securely while transitioning to a new country.'
        },
        {
          id: 4,
          title: 'Frequent Travelers',
          description: 'Store luggage and valuables during long trips for added convenience and security.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/who-should-use-our-international-services.jpg',
        alt: 'Who Should Use Our International Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our International Services',

  cards: [
    {
      id: 1,
      title: 'Global Shipping Solutions',
      description: 'Fast, reliable shipping services to anywhere in the world.',
      image: {
        src: '/images/v2/pages/common/global-shipping-solutions.png',
        alt: 'Global Shipping Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Customs Assistance',
      description: 'We handle all customs and regulatory requirements to ensure a smooth process.',
      image: {
        src: '/images/v2/pages/common/customs-assistance.png',
        alt: 'Customs Assistance'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'International Storage Options',
      description: 'Secure storage for personal and business needs during your global transitions.',
      image: {
        src: '/images/v2/pages/common/international-storage-options.png',
        alt: 'International Storage Options'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Specialty Item Shipping',
      description: 'Ship fragile, oversized, or unique items with care and expertise.',
      image: {
        src: '/images/v2/pages/common/specialty-item-shipping.png',
        alt: 'Specialty Item Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for International Shipping and Storage?',

  image: {
    url: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/why-choose-us-for-international-shipping-and-storage.jpg',
    alt: 'Why Choose Us for International Shipping and Storage?'
  },

  articles: [
    {
      id: 1,
      title: 'Comprehensive Solutions',
      description: 'From storage to shipping, we manage every step of the process for you.'
    },
    {
      id: 2,
      title: 'Expert Guidance',
      description: 'Our team of experts provides personalized support for customs, logistics, and packing.'
    },
    {
      id: 3,
      title: 'Customizable Services',
      description: 'Tailor your plan to meet your unique needs, from storage duration to shipping speed.'
    },
    {
      id: 4,
      title: 'Reliable Partners',
      description: 'We collaborate with top global carriers to ensure fast and secure deliveries.'
    },
    {
      id: 5,
      title: 'Advanced Security',
      description: 'Your items are protected with 24/7 monitoring, gated access, and secure handling.'
    },
    {
      id: 6,
      title: 'Transparent Pricing',
      description: 'Clear and competitive pricing with no hidden fees or surprises.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'International Shipping And Storage Services Available Now',
  description:
    'International Shipping and storage services available. Affordable, fast, and secure solutions for all your international storage needs.',
  image: {
    src: '/images/v2/pages/landing-pages/international-shipping-and-storage-services/international-shipping-and-storage-services-available-now.png',
    alt: 'International Shipping And Storage Services Available Now'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Your International Journey' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping Partners',
  description: 'We collaborate with industry-leading shipping providers to offer seamless logistics support.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx offers express and reliable international shipping with tracking for peace of mind.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL specializes in global logistics, ensuring timely and efficient delivery across borders.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides comprehensive international shipping services, handling everything from customs to delivery.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
